import { Navigate } from 'react-router-dom';

import { useTeamSankeysQuery } from '../api';
import LoadingPage from '../components/LoadingPage';
import { Path, pathToSankey, websiteLinkTo } from '../utils/routes';
import { useCurrentUser } from '../utils/user';

// This page is used to redirect the user to Sankey editor page if they have any Sankeys.
// TODO: Make sure this still works in https://github.com/sankeyart/sankeyart/pull/1681
const SankeysEditorRedirectPage: React.FC = () => {
  const { user } = useCurrentUser();
  const { data, isLoading } = useTeamSankeysQuery();

  // If the user is not signed in, redirect them to the login page with a redirect back to this page
  // TODO: Abstract this logic into an AuthorizedRoute component once we have universal React sign-in
  // flow with redirects supported both by the add-in and the web app.
  if (!user) {
    window.location.href = websiteLinkTo(
      `/accounts/login/?next=${Path.SankeysEditorRedirect}`
    );
  }

  // Show a loading page while we're fetching the user's Sankeys
  if (isLoading) {
    return <LoadingPage />;
  }

  // Redirect the user to the first Sankey they own, or to the Sankeys overview page if they don't own any Sankeys.
  const myFirstSankey = data?.[0];
  return (
    <Navigate
      to={myFirstSankey ? pathToSankey(myFirstSankey.id) : Path.Sankeys}
      replace
    />
  );
};

export default SankeysEditorRedirectPage;
